import { isProductionHost } from "./hostEnv";

/** GA4 プロパティ「Verite - GA4」(546706628) — ストリーム: Verite 本番 verite-f.co.jp */
export const GA_MEASUREMENT_ID = "G-JJEY19E2FS";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let initialized = false;

export function initAnalytics(): void {
  if (initialized || typeof window === "undefined" || !isProductionHost()) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackPageView(pagePath: string, pageTitle?: string): void {
  if (!initialized || !window.gtag || !isProductionHost()) return;
  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_title: pageTitle ?? document.title,
    page_location: window.location.href,
  });
}
